"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TableEditIcon_1 = __importDefault(require("mdi-react/TableEditIcon"));
var DragVariantIcon_1 = __importDefault(require("mdi-react/DragVariantIcon"));
var TableColumnPlusAfterIcon_1 = __importDefault(require("mdi-react/TableColumnPlusAfterIcon"));
var TableColumnRemoveIcon_1 = __importDefault(require("mdi-react/TableColumnRemoveIcon"));
var material_1 = require("@mui/material");
var ToggleEditableButton = function (_a) {
    var editMode = _a.editMode, currentTableObj = _a.currentTableObj, t = _a.t, toggleEditMode = _a.toggleEditMode, disableEditSchema = _a.disableEditSchema, hasSchemaFields = _a.hasSchemaFields;
    var Icon = editMode ? DragVariantIcon_1.default : TableEditIcon_1.default;
    var showEditSchemaButtons = editMode && !disableEditSchema;
    return (react_1.default.createElement(material_1.ButtonGroup, { size: 'small', style: {
            position: 'absolute',
            left: '0px',
            top: '-30px',
            maxWidth: '120px',
            userSelect: 'auto',
            pointerEvents: 'auto',
            maxHeight: '25px',
            backgroundColor: '#fafafa',
            color: 'black'
        } },
        react_1.default.createElement(material_1.Tooltip, { disableInteractive: true, title: t("contents.widgets.table.".concat(editMode ? 'changePosition' : 'changeValues')) },
            react_1.default.createElement(material_1.Button, { id: 'table-toggle-button', onClick: toggleEditMode, size: 'small', variant: 'outlined' },
                react_1.default.createElement(Icon, null))),
        showEditSchemaButtons && hasSchemaFields && (react_1.default.createElement(material_1.Tooltip, { title: t('contents.widgets.table.deleteLastField'), disableInteractive: true },
            react_1.default.createElement(material_1.Button, { id: 'table-delete-field-button', onClick: function () { return currentTableObj === null || currentTableObj === void 0 ? void 0 : currentTableObj.deleteSchemaField(); }, size: 'small', variant: 'outlined' },
                react_1.default.createElement(TableColumnRemoveIcon_1.default, null)))),
        showEditSchemaButtons && (react_1.default.createElement(material_1.Tooltip, { title: t('contents.widgets.table.addTextField'), disableInteractive: true },
            react_1.default.createElement(material_1.Button, { id: 'table-add-field-button', onClick: function () { return currentTableObj === null || currentTableObj === void 0 ? void 0 : currentTableObj.addSchemaField(); }, size: 'small', variant: 'outlined' },
                react_1.default.createElement(TableColumnPlusAfterIcon_1.default, null))))));
};
exports.default = ToggleEditableButton;
//# sourceMappingURL=ToggleEditableButton.js.map